import { gsap, ScrollTrigger } from "../globals/gsap";
import Header from "../globals/header";

class DefaultTransition {
  duration = 0.5;

  leave(data){
    console.log('leave transiton');

    const done = this.async();

    gsap.to(data.current.container, {
      opacity: 0,
      duration: this.duration,
      onComplete: done,
    });
  }

  enter(data){
    console.log('enter transiton');
    const nextContainer = data.next.container;

    gsap.from(nextContainer, {
      opacity: 0,
      duration: this.duration,
      onComplete: () => {
        ScrollTrigger.refresh();
        // ScrollTrigger.update();
      },
    });
  }

}

export default new DefaultTransition();